import { render, staticRenderFns } from "./AdminUserEditor.vue?vue&type=template&id=1128696c&scoped=true"
import script from "./AdminUserEditor.vue?vue&type=script&lang=js"
export * from "./AdminUserEditor.vue?vue&type=script&lang=js"
import style0 from "./AdminUserEditor.vue?vue&type=style&index=0&id=1128696c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1128696c",
  null
  
)

export default component.exports